export interface PolicySearchContent {
  HEADER_TEXT: string;
  POLICY: string;
  ZIPCODE: string;
  PHONE_NUMBER: string;
  REQUIRED_SUFFIX?: string;
  POLICY_INSTRUCTION?: string;
  SUB_HEADING?: string;
  BODY_TEXT_INSTRUCT?: string;
  BODY_TEXT?: string;
}

export const GRACE_PAYMENT_CONTENT: PolicySearchContent = {
  HEADER_TEXT: 'Make your one-time grace period payment',
  POLICY: 'Policy number',
  ZIPCODE: 'ZIP code',
  PHONE_NUMBER: 'Phone number',
  REQUIRED_SUFFIX: ' (required)',
  POLICY_INSTRUCTION:'You can find this on a bill or statement. If you still can’t find it, contact your financial professional.',
  SUB_HEADING:'Let’s find your policy.',
  BODY_TEXT_INSTRUCT: 'Make sure you’re using the same ZIP code and phone number below that you put on your application.',
  BODY_TEXT: 'Using this online process, you can keep your life insurance policy active by making your grace period payment. Fill in the 3 required fields below to get started.'
};


export const INITIAL_PAYMENT_CONTENT: PolicySearchContent = {
  HEADER_TEXT: 'Make your initial payment',
  POLICY: 'Policy number',
  ZIPCODE: 'ZIP code',
  PHONE_NUMBER: 'Phone number',
  POLICY_INSTRUCTION:'Your financial professional should have provided your policy number when you applied for this product, so reach out to them if you don’t have it.',
  SUB_HEADING:'Let’s find your pending policy.',
  BODY_TEXT_INSTRUCT: 'Make sure you’re using the same ZIP code and phone number below that you put on your application.',
  BODY_TEXT: 'You can activate your life insurance policy by making your initial premium payment using this online process. Just fill in the 3 required fields below to get started.'
};

export const ACTIVE_POLICY_PAYMENT_CONTENT: PolicySearchContent = {
  HEADER_TEXT: 'Let’s find your policy first.',
  POLICY: 'Policy number',
  ZIPCODE: 'ZIP code',
  PHONE_NUMBER: 'Phone number'
};

